import { RouteProps } from '../../routes/AppRouter'
import { PatientFormsTable as PFT } from '../../features/form-patients'
import React from 'react'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function PatientFormsTable(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <PFT />
}
